import type { CustomElement } from "@github/catalyst/lib/custom-element";
import { bind } from "@github/catalyst";
import { autoShadowRoot } from "@github/catalyst/lib/auto-shadow-root";
import { defineObservedAttributes, initializeAttrs } from "@github/catalyst/lib/attr";
import { bindShadow } from "@github/catalyst/lib/bind";

export function controller(classObject: CustomElement): void {
  const connect = classObject.prototype.connectedCallback;
  classObject.prototype.connectedCallback = function (this: HTMLElement) {
    this.toggleAttribute("data-catalyst", true);
    autoShadowRoot(this);
    initializeAttrs(this);
    bind(this);
    if (connect) connect.call(this);
    if (this.shadowRoot) bindShadow(this.shadowRoot);
  };
  defineObservedAttributes(classObject);
}
